import TiersScreen from "@/UI/screens/TiersScreen";

export default function TiersRoute() {
    return <TiersScreen />;
}
